import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LoggingService } from '@com-delta-idp/mnx-utils';
import { of } from 'rxjs';
import { Observable } from 'rxjs/Observable';
import { catchError, map, share } from 'rxjs/operators';
import { ApplicationConfig } from '../../config/config';
import {
  SiteSearchPERequest,
  SiteSearchPEResponse
} from '../../model/site-search-pe.model';

@Injectable({
  providedIn: 'root'
})
export class SiteSearchPeService {
  public peResponse: SiteSearchPEResponse;
  private _contentObservable: Observable<SiteSearchPEResponse>;
  constructor(
    private _http: HttpClient,
    private config: ApplicationConfig,
    private loggingService: LoggingService
  ) {}

  getSiteSearchUrl(
    peRequest: SiteSearchPERequest
  ): Observable<SiteSearchPEResponse> {
    if (this.peResponse) {
      return of(this.peResponse);
    } else if (this._contentObservable) {
      return this._contentObservable;
    } else {
      const body = JSON.stringify(peRequest);
      const customheaders = new HttpHeaders({
        'Content-Type': 'application/json; charset=utf-8'
      });
      this._contentObservable = this._http
        .post<SiteSearchPEResponse>(
          `${this.config.get('APP_PE_DATA_URL')}`,
          body,
          {
            headers: customheaders,
            responseType: 'json'
          }
        )
        .pipe(
          map((data) => {
            this._contentObservable = null;
            this.peResponse = data;
            return this.peResponse;
          }),
          catchError((e) => {
            this.loggingService.log(
              'Caught Error In SiteSearchPeService: ' + e
            );
            return of(this.peResponse);
          })
        )
        .pipe(share());
    }
    return this._contentObservable;
  }
}
